import(/* webpackMode: "eager" */ "/var/www/lumi/apps/parent/src/app/error.tsx");
